import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { cn, PaletteUtils, RoutePaths } from '@shared/utils';
import { TransferRecipientTypeEnum } from '@shared/api';
import { BusinessRecipient, IndividualRecipient } from './widgets';
import { PageContainer } from '@widgets';
import { Icon, Tabs, Text } from '@shared/widgets';
import ArrowIcon from '@assets/icons/arrow.svg';
import ArrowVCFCIcon from '@assets/icons/arrow-vcfc.svg';

export const RecipientEditorPage = () => {
  const [tab, setTab] = useState<TransferRecipientTypeEnum>(TransferRecipientTypeEnum.Individual);

  const { t } = useTranslation('recipientEditor');

  const tabs = useMemo(
    () =>
      Object.entries(TransferRecipientTypeEnum).map(([, value]) => ({ label: t(`recipientType.${value.toLowerCase()}`, { ns: 'common' }), value })),
    [t],
  );
  return (
    <PageContainer
      title={t('title')}
      header={
        <Link className='group flex items-center gap-2' to={RoutePaths.payments.onNavigate()}>
          <Icon
            className={cn(PaletteUtils.isInsigniaPalette && 'rotate-180')}
            icon={PaletteUtils.isInsigniaPalette ? <ArrowIcon /> : <ArrowVCFCIcon className='text-black dark:text-white' />}
          />
          {PaletteUtils.isInsigniaPalette ? (
            <Text weight='semibold' size='2xl'>
              {t('header')}
            </Text>
          ) : (
            <Text className='group-hover:underline' size='sm'>
              {t('return')}
            </Text>
          )}
        </Link>
      }
    >
      <div className='flex flex-col gap-6 rounded-xl bg-white p-6 dark:bg-soft-black'>
        <Text weight='semibold' size='2xl'>
          {t('title')}
        </Text>
        <Tabs options={tabs} value={tab} onChange={setTab} />
        {tab == TransferRecipientTypeEnum.Individual && <IndividualRecipient />}
        {tab === TransferRecipientTypeEnum.Business && <BusinessRecipient />}
      </div>
    </PageContainer>
  );
};
